<template>
    <div class="estadisticas-asistencias">
        <v-container grid-list-xl fluid class="pt-0">
            <v-layout row wrap>
                <v-flex sm12>
                    <v-card>
                        <v-toolbar color="primary" dark flat dense>
                            <v-toolbar-title>
                                Asistencias de los empleados
                            </v-toolbar-title>
                        </v-toolbar>

                        <v-card-text class="pa-0">
                            <v-card>
                                <v-card-title>
                                    Agrupar por
                                    <v-select
                                        v-model="SectionCategorie"
                                        :items="items"
                                        item-text="text"
                                        item-value="value"
                                        placeholder="seleccione..."
                                        dense
                                        return-object
                                        class="pl-2"
                                        style="max-width: 30%"
                                    >
                                    </v-select>

                                    <v-spacer></v-spacer>
                                    <v-btn icon flat @click="showMenu">
                                        <v-icon medium>fa fa-search</v-icon>
                                    </v-btn>
                                </v-card-title>

                                <v-card-text class="pa-2  text-xs-center">
                                    <template v-if="SectionCategorie">
                                        <bar-chart
                                            :title="`Asistencias por ${SectionCategorie.text}`"
                                            :cols="$store.getters.STATS_ASISTENCIAS.cols"
                                            :data="$store.getters.STATS_ASISTENCIAS.data"
                                            key="1"
                                        ></bar-chart>
                                    </template>
                                </v-card-text>
                            </v-card>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>

        <v-menu
            v-model="filterMenu"
            transition="scale-transition"
            :position-x="x"
            :position-y="y"
            absolute
            :close-on-content-click="false"
        >
            <v-card dark>
                <v-card-title>Filtrar empleados por:</v-card-title>
                <v-card-text class="pa-0 px-2 pb-2">
                    <v-radio-group v-model="filterType" row color="primary" @change="choosenFilter = null">
                        <v-radio label="Campus" value="Campus"> </v-radio>
                        <v-radio label="Sección" value="Sección"> </v-radio>
                        <v-radio label="Departamento" value="Departamento"> </v-radio>
                    </v-radio-group>

                    <v-select
                        v-model="choosenFilter"
                        :items="filterItems"
                        item-text="nombre"
                        item-value="id"
                        placeholder="seleccione..."
                        return-object
                    >
                    </v-select>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" small flat :disabled="!choosenFilter" @click="applyFilter"
                            >Aplicar</v-btn
                        >
                    </v-card-actions>
                </v-card-text>
            </v-card>
        </v-menu>
    </div>
</template>

<script>
const BarChart = () => import("@/components/widgets/bar-chart/BarChart")

export default {
    components: { BarChart },
    data() {
        return {
            //menuFilter
            filterMenu: false,
            x: 0,
            y: 0,
            filterType: null,
            choosenFilter: null,

            //categorias seleccionadas
            SectionCategorie: "",

            //items agrupar por
            items: [{ text: "Campus", value: 1 }, { text: "Sección", value: 2 }, { text: "Departamento", value: 3 }]
        }
    },

    methods: {
        showMenu(e) {
            this.filterMenu = false

            this.x = e.clientX
            this.y = e.clientY
            this.$nextTick(() => {
                this.filterMenu = true
            })
        },

        applyFilter() {
            this.filterMenu = false
        }
    },

    computed: {
        filterItems() {
            if (this.filterType) {
                switch (this.filterType) {
                    case "Campus":
                        return this.$store.getters.CAMPUS
                    case "Sección":
                        return this.$store.getters.SECCIONES
                    case "Departamento":
                        return this.$store.getters.DEPARTAMENTOS
                }
            }
            return []
        }
    },

    mounted() {
        this.$store.dispatch("LOAD_ALL_CAMPUS")
        this.$store.dispatch("LOAD_ALL_SECCIONES")
        this.$store.dispatch("LOAD_ALL_DEPARTAMENTOS")
    }
}
</script>
